<template>
  <div>
  <AboutSection
        :image1="require('@/assets/AllSystem/pa/image1.png')"
        :image2="require('@/assets/AllSystem/pa/image2.png')"
        :section1="$t('menus.pa.about_us.section1')"
        :section2Title="$t('menus.pa.about_us.section2.title')"
        :section2Content="$t('menus.pa.about_us.section2.content')"
        :administration="administrationObj"
  />
  </div>
</template>

<script>
 import AboutSection from '../share/AboutUs.vue'


export default {
    components: {
      AboutSection
    },
    computed: {
      administrationObj() {
        return {
          title: this.$t('menus.pa.about_us.administration.title') || '',
          fullname: this.$t('menus.pa.about_us.administration.fullname') || '',
          tel: this.$t('menus.pa.about_us.administration.tel') || '',
          email: this.$t('menus.pa.about_us.administration.email') || '',
          address: this.$t('menus.pa.about_us.administration.address') || ''
        };
    }
}

}
</script>

  <style scoped>
  .textBox:first-child{
    border-right:4px solid #F5BD2A;
    padding-right:10px;
  }
  .textBox:nth-child(2){
    border-left:4px solid #F5BD2A;
    padding-left:10px;
  }
  </style>